/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	getEvent: (state) => (eventId) => state.events.find((event) => event.id === eventId),
	getEventByCalendarId: (state) => (eventId) => state.events.find((event) => event.calendarId === eventId),
	getCurrentResource: (state) => state.currentResource,
};
